import { createSlice } from '@reduxjs/toolkit'
import { getCommunityAccessControl } from '../actions/accessControlActions'
import { createCommunityAccessEntry } from '../actions/accessEntryActions'

const initialState = {
  description: '',
  code: '',
  community: null,
  error: '',
  isLoading: false,
  permittedAt: '',
}

const landingAccessReducer = createSlice({
  name: 'landingAccess',
  initialState,
  reducers: {
    setCode: (state, action) => {
      state.code = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    refreshPermittedAt: (state) => {
      state.permittedAt = Date.now()
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getCommunityAccessControl.fulfilled, (state, action) => {
        const accessControl = action.payload.accessControl

        state.description = accessControl.description
        state.community = accessControl.community
      })

      .addCase(createCommunityAccessEntry.pending, (state) => {
        state.error = ''
        state.isLoading = true
      })
      .addCase(createCommunityAccessEntry.fulfilled, (state, _) => {
        state.isLoading = false
        state.code = ''
        state.error = ''
      })
      .addCase(createCommunityAccessEntry.rejected, (state, _) => {
        state.isLoading = false
        state.code = ''
        state.error = 'The code you entered is invalid.'
      })
  },
})

export const { setCode, setError, refreshPermittedAt } = landingAccessReducer.actions

export default landingAccessReducer.reducer
